var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSymptomGenitalSoresUlcers(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 119,
    height: 114,
    viewBox: "0 0 119 114",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 10C0 4.47716 4.47715 0 10 0H109C114.523 0 119 4.47715 119 10V114H0V10Z",
    fill: "#4B5AA7",
    fillOpacity: 0.1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59 95.0001C76.6732 95.0001 91.0001 80.6732 91.0001 63C91.0001 45.3269 76.6732 31 59 31C41.3269 31 27 45.3269 27 63C27 80.6732 41.3269 95.0001 59 95.0001Z",
    fill: "#4B5AA7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.9999 95C67.2236 95 74.723 91.8895 80.3902 86.8189C82.9041 78.2117 85.1624 65.6844 80.2624 57.7163C76.044 50.8135 77.0239 43.4421 78.9415 38.0305C73.4872 33.6419 66.5419 31 58.9999 31C51.458 31 44.5125 33.6419 39.0585 37.988C40.9759 43.4421 41.9986 50.8136 37.7376 57.6738C32.8376 65.6419 35.0958 78.1692 37.6098 86.7764C43.2769 91.8895 50.7762 95 58.9999 95Z",
    fill: "#F7CFA2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59 95.0001C59.213 95.0001 59.4261 95.0001 59.6391 95.0001V72.1612L67.3515 64.4489C67.6071 64.1933 67.6071 63.8097 67.3515 63.554C67.0959 63.2984 66.7124 63.2984 66.4566 63.554L58.9999 71.0108L51.5431 63.554C51.2875 63.2984 50.904 63.2984 50.6482 63.554C50.3926 63.8096 50.3926 64.1931 50.6482 64.4489L58.3606 72.1612V94.9575C58.5739 95.0001 58.7869 95.0001 59 95.0001Z",
    fill: "#F0BA7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.9999 42.9735C59.9648 42.9735 60.7469 42.1913 60.7469 41.2265C60.7469 40.2617 59.9648 39.4795 58.9999 39.4795C58.0351 39.4795 57.2529 40.2617 57.2529 41.2265C57.2529 42.1913 58.0351 42.9735 58.9999 42.9735Z",
    fill: "#F0BA7A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white",
    transform: "translate(27 31)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymptomGenitalSoresUlcers);
export default __webpack_public_path__ + "static/media/symptom-Genital-Sores-&-Ulcers.7fc27aa307b52b3ec268f92ddaf80406.svg";
export { ForwardRef as ReactComponent };